"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpiceSimulationFailureMode = void 0;
var SpiceSimulationFailureMode;
(function (SpiceSimulationFailureMode) {
    SpiceSimulationFailureMode["CircuitSerializationError"] = "CircuitSerializationError";
    SpiceSimulationFailureMode["SimulationExecutionError"] = "SimulationExecutionError";
    SpiceSimulationFailureMode["SimulationParsingError"] = "SimulationParsingError";
    SpiceSimulationFailureMode["SimulationRunError"] = "SimulationRunError";
    SpiceSimulationFailureMode["SimulationConvergenceError"] = "SimulationConvergenceError";
    SpiceSimulationFailureMode["SimulationAbortedError"] = "SimulationAbortedError";
    SpiceSimulationFailureMode["SimulationTimedOutError"] = "SimulationTimedOutError";
    SpiceSimulationFailureMode["ResultParseError"] = "ResultParseError";
    SpiceSimulationFailureMode["ResultCorrelationError"] = "ResultCorrelationError";
    SpiceSimulationFailureMode["ResultAnalysisError"] = "ResultAnalysisError";
    SpiceSimulationFailureMode["UnknownSpiceError"] = "UnknownSpiceError";
})(SpiceSimulationFailureMode || (exports.SpiceSimulationFailureMode = SpiceSimulationFailureMode = {}));
//# sourceMappingURL=SpiceSimulationFailureMode.js.map